import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { FACULTY } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={FACULTY} id={id} />;
}

export const Route = createFileRoute("/_app/departments/faculty/$id")({
  component: Edit,
});
